import { State } from "./state";
import { storeInit } from "../../../Store";
const initialIpConfig: State.Data = {
  ip: "",
  sn: "",
  gw: "",
  meth: "STATIC"
};

export const initial: State.Props = storeInit(initialIpConfig);
export default initial;
